import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { RestrictionsState } from "./types";

import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

export const state: RestrictionsState = {
  restrictions: [],
  restriction: undefined
}

export const restrictions: Module<RestrictionsState, RootState> = {
  state,
  getters,
  actions,
  mutations
}